import { render } from "./VUEPopupDatiStorici.vue?vue&type=template&id=87f979fa"
import script from "./VUEPopupDatiStorici.vue?vue&type=script&lang=js"
export * from "./VUEPopupDatiStorici.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__